import { memo } from "react"

export const FluidPackages = memo(() => {
  return <div>Fluid packages</div>
})